import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatasourceDownstreamFlowsWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatasourceDownstreamFlowsWithoutPersonalSpaceQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
